var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowForward = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  className: "arrowForward_svg__svg-safari-fix",
  viewBox: "0 0 24 24",
  "aria-hidden": props["aria-label"] || props["aria-labelledby"] ? undefined : true
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M9.222 5.301a7.25 7.25 0 0 1 7.902 1.575l1.475 1.47h-2.08a1 1 0 1 0 0 2h4.48a.997.997 0 0 0 1.02-1v-4.5a1 1 0 1 0-2 0v2.092L18.538 5.46a9.25 9.25 0 1 0 0 13.077 1 1 0 1 0-1.414-1.414A7.25 7.25 0 1 1 9.222 5.301",
  clipRule: "evenodd"
})));
export default SvgArrowForward;